<template>
  <v-container fluid fill-height>
    <v-layout justify-center align-center>
      <v-flex shrink>
        <v-card class="elevation-12">
          <v-toolbar color="blue-grey lighten-1">
            <div>
              <v-toolbar-title>Willkommen</v-toolbar-title>
              <div
                style="display: block!important; margin-left: 16px!important"
              >Bitte logge Dich mit Deinem Usernamen ein</div>
            </div>
            <v-spacer></v-spacer>
          </v-toolbar>
          <v-card-text>
            <!-- v-model="isFormValid" -->
            <v-text-field
              prepend-icon="person"
              name="login"
              v-model="username"
              label="Username"
              type="text"
              autocomplete="off"
              v-on:keyup.enter.prevent="login"
            ></v-text-field>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" v-on:click.prevent="login" v-bind:loading="isLoading">Login</v-btn>
          </v-card-actions>
          <!-- <transition mode="out-in" name="fade"> -->
          <v-alert
            v-model="isLoginError"
            type="error"
            dismissible
            transition="scale-transition"
            origin="center center"
          >{{loginError}}</v-alert>
          <!-- </transition> -->
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import axios from "axios";

export default {
  data: () => ({
    username: null,

    isLoading: false,

    isLoginError: false,
    loginError: ""
  }),

  methods: {
    login() {
      this.isLoginError = false;
      this.loginError = "";
      localStorage.removeItem("u");

      if (!this.username) {
        this.isLoginError = true;
        this.loginError = "Username ist leer.";
        return;
      }

      this.isLoading = true;

      const url = process.env.VUE_APP_APIBASEURL + "/checkuser";
      console.log("checking user via API:", url);
      axios
        .get(url, { headers: { user: this.username } })
        .finally(() => {
          this.isLoading = false;
        })
        .then(response => {
          localStorage.setItem("u", this.username);
          this.$router.push("/allgames");
        })
        .catch(error => {
          this.isLoginError = true;

          this.loginError = error.message;

          if (error.response.data && error.response.data.error) {
            this.loginError = error.response.data.error;
          }

          return;
        });
    }
  }
};
</script>

<style>
</style>
